module.exports = __webpack_public_path__ + "img/hexagonHover.28e3cbb8.png";